import { Navigate, Outlet } from 'react-router-dom';

const ProtectedRoute = () => {
  // Check both localStorage and Redux state
  const isAuthenticatedLocal = localStorage.getItem('isAuthenticated');
  const token = localStorage.getItem('token');

  // If no authentication found, redirect to login
  if (!isAuthenticatedLocal || !token) {
    return <Navigate to="/login" replace />;
  }

  // Optional: Add loading state while checking auth
  // if (isAuthenticatedLocal && !isAuthenticatedRedux) {
  //   return (
  //     <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
  //       <CircularProgress />
  //     </Box>
  //   );
  // }

  // Returns child route elements
  return <Outlet />;
};

export default ProtectedRoute;

